module.exports = __webpack_public_path__ + "static/media/floor_n.1f5cae0f.png";